module.exports = __webpack_public_path__ + "static/media/car_new.737f205b.jpg";